/**
 * TeamTalk shared helpers + constants.
 * Extracted from TeamTalkInbox.jsx (V1.7.9 refactor).
 */

export const REFRESH_INTERVAL_MS = 15000;  // V1.9.17 — tightened fallback poll interval
export const MAX_ATTACHMENT_MB = 25;
export const TYPING_PING_INTERVAL_MS = 2500;
export const TYPING_EXPIRE_MS = 4000;

export function formatWhen(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        const diff = (Date.now() - d.getTime()) / 1000;
        if (diff < 60) return "just now";
        if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
        if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
        return d.toLocaleDateString();
    } catch { return ""; }
}

export function roleLabel(r) {
    if (!r) return "Staff";
    if (r === "hiring_manager") return "Hiring Mgr";
    if (r === "superadmin") return "Superadmin";
    if (r === "group") return "Group";
    return r.charAt(0).toUpperCase() + r.slice(1);
}

/**
 * Compute read-receipt state for a message *I* sent.
 * Returns { seen, seenAll, seenBy: [name], total, isGroup } based on
 * `convo.thread.last_read_at_by_user`.
 */
export function computeReadReceipt(m, convo, myUserId) {
    const map = convo?.thread?.last_read_at_by_user || {};
    const members = (convo?.members || []).filter((u) => u.id !== myUserId);
    const seenBy = [];
    for (const u of members) {
        const ts = map[u.id];
        if (ts && new Date(ts).getTime() >= new Date(m.created_at).getTime()) {
            seenBy.push(u.name || "Teammate");
        }
    }
    const isGroup = Boolean(convo?.thread?.is_group);
    return {
        seen: seenBy.length > 0,
        seenAll: seenBy.length === members.length && members.length > 0,
        seenBy,
        total: members.length,
        isGroup,
    };
}

export function bytesToLabel(bytes) {
    if (!bytes || bytes < 0) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
